import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiFetch } from './utils/api';

function UnassignedJobs() {
  const navigate = useNavigate();
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    fetchUnassignedJobs();
  }, []);

  const fetchUnassignedJobs = async () => {
    try {
      const res = await apiFetch('/api/jobs/unassigned');
      const data = await res.json();
      setJobs(Array.isArray(data) ? data : []);
      setLoading(false);
    } catch (err) {
      console.error('Error fetching unassigned jobs:', err);
      setJobs([]);
      setLoading(false);
    }
  };

  const filteredJobs = jobs.filter(job =>
    (job.job_number || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
    (job.site_address || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
    (job.site_contact || '').toLowerCase().includes(searchTerm.toLowerCase())
  );

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-orange-600"></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-gradient-to-r from-orange-600 to-orange-700 text-white shadow-md">
        <div className="max-w-full mx-auto px-6 py-2">
          <div className="flex items-center justify-between">
            <h1 className="text-2xl font-light">Unassigned Jobs</h1>
            <button 
              onClick={() => navigate('/jobs')}
              className="px-4 py-2 bg-white/10 hover:bg-white/20 backdrop-blur-sm rounded-lg font-medium transition border border-white/20"
            >
              View All Jobs
            </button>
          </div>
        </div>
      </div>

      {/* Search Bar */}
      <div className="max-w-full mx-auto px-6 py-3">
        <input
          type="text"
          placeholder="🔍 Search unassigned jobs..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
        />
      </div>

      {/* Jobs Table */}
      <div className="max-w-full mx-auto px-6 pb-6">
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
          <table className="w-full">
            <thead className="bg-gray-50 border-b border-gray-200">
              <tr>
                <th className="text-left px-3 py-2 text-xs font-semibold text-gray-600 uppercase">Job #</th>
                <th className="text-left px-3 py-2 text-xs font-semibold text-gray-600 uppercase">Site Address</th>
                <th className="text-left px-3 py-2 text-xs font-semibold text-gray-600 uppercase">Category</th>
                <th className="text-left px-3 py-2 text-xs font-semibold text-gray-600 uppercase">Contact</th>
                <th className="text-left px-3 py-2 text-xs font-semibold text-gray-600 uppercase">Created</th>
                <th className="text-right px-3 py-2 text-xs font-semibold text-gray-600 uppercase">Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredJobs.map((job, index) => (
                <tr
                  key={job.id}
                  className={`hover:bg-orange-100 cursor-pointer transition border-b border-gray-100 ${
                    index % 2 === 1 ? 'bg-orange-100' : 'bg-white'
                  }`}
                  onClick={() => navigate(`/jobs/${job.id}`)}
                >
                  <td className="px-3 py-2">
                    <span className="font-mono text-sm font-semibold text-gray-900">{job.job_number}</span>
                  </td>
                  <td className="px-3 py-2 text-sm text-gray-900">{job.site_address || '—'}</td>
                  <td className="px-3 py-2 text-sm text-gray-600">{job.job_category || '—'}</td>
                  <td className="px-3 py-2 text-sm text-gray-600">{job.site_contact || '—'}</td>
                  <td className="px-3 py-2 text-sm text-gray-600">
                    {job.created_at ? new Date(job.created_at).toLocaleDateString() : '—'}
                  </td>
                  <td className="px-3 py-2 text-right">
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        navigate(`/jobs/${job.id}/appointment`);
                      }}
                      className="px-3 py-1 bg-orange-600 hover:bg-orange-700 text-white text-xs font-medium rounded transition mr-2"
                    >
                      Create Appointment
                    </button>
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        navigate(`/jobs/${job.id}`);
                      }}
                      className="text-orange-600 hover:text-orange-800 text-xs font-medium"
                    >
                      View
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {filteredJobs.length === 0 && (
            <div className="text-center py-12">
              <div className="text-6xl mb-4">✅</div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">All jobs assigned!</h3>
              <p className="text-gray-500 mb-4">
                {searchTerm ? 'No unassigned jobs match your search' : 'All jobs have appointments'}
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default UnassignedJobs;
